import Vue from 'vue'
import machine from '../machine'

Vue.prototype.$machine = machine
